export default __webpack_public_path__ + "static/media/icone-alerta.5343365d.png";